import React from 'react';
import { Button, Tooltip } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const types = {
  primaryInvert: 'primary-invert',
  danger: 'danger',
};

const typeClasses = {
  [types.primaryInvert]: styles.primaryInvert,
  [types.danger]: styles.danger,
};

const OptionButton = ({
  sizeWithUnit,
  type,
  onClick,
  icon,
  tooltipTitle,
  className,
}) => {
  const validType = types[type] ? type : types.primaryInvert;

  return (
    <Tooltip title={tooltipTitle}>
      <Button
        style={{ '--remove-option-btn-size': sizeWithUnit }}
        shape="circle"
        icon={icon}
        type="ghost"
        className={cn(styles.root, typeClasses[validType], className)}
        onClick={onClick}
      />
    </Tooltip>
  );
};

OptionButton.types = types;

export default OptionButton;
